export function copyValue(value: string) {
  const hiddenField = document.createElement('textarea');
  document.body.appendChild(hiddenField);
  hiddenField.value = value;
  hiddenField.select();
  document.execCommand('copy');
  document.body.removeChild(hiddenField);
}
